// extracted by mini-css-extract-plugin
export var infoRow = "_mr-2";
export var labelContainer = "_mr-0";
export var rightInfo = "_mr-1";